import { Component, Inject } from '@angular/core';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/shared/utils/no-whitespace-validator';

interface RecallActionDialogData {
  title: string;
  description?: string;
}

@Component({
    selector: 'app-recall-action-dialog',
    imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatDividerModule,
    DragDropModule,
    ReactiveFormsModule
],
    template: `
    <div style="height: 8px; background-color: rgba(16, 46, 94, 0.982)" class="col-12"></div>
    <div style="display: flex; width: 100%; align-items: center;">
      <h1 mat-dialog-title class="titre-modale">{{ data.title }}</h1>
      <button class="py-0" mat-icon-button aria-label="Fermer la modale" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <mat-dialog-content class="mat-typography pt-0 dialog-content">
      <div class="dialog-body">
        <mat-divider></mat-divider>
        <!-- <div class="content-text mt-2 mb-3">
        {{ data.description }}
      </div> -->
      <mat-form-field class="example-full-width" floatLabel="always" style="width: 100%">
        <mat-label>Motif</mat-label>
        <textarea
          class="pt-0"
          matInput
          id="motif"
          [formControl]="motifControl"
          rows="4"
          placeholder="Saisissez un motif obligatoire"
        ></textarea>
        @if (motifControl.hasError('required')) {
          <mat-error>Le motif est obligatoire.</mat-error>
        }
        @if (motifControl.hasError('whitespace')) {
          <mat-error>Le motif ne peut pas être vide.</mat-error>
        }
      </mat-form-field>
      <mat-divider></mat-divider>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions style="background-color: rgba(250, 250, 252, 1)" align="end">
      <button mat-stroked-button class="mx-3" color="primary" (click)="onCancel()">Annuler</button>
      <button mat-flat-button color="primary" (click)="onConfirm()" cdkFocusInitial>Confirmer</button>
    </mat-dialog-actions>
    `,
    styleUrls: ['./recall-action-dialog.component.scss']
})
export class RecallActionDialogComponent {
  motifControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, noWhitespaceValidator]
  });

  constructor(
    private readonly dialogRef: MatDialogRef<RecallActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecallActionDialogData
  ) {}

  onConfirm(): void {
    if (this.motifControl.invalid) {
      this.motifControl.markAsTouched();
      return;
    }
    this.dialogRef.close(this.motifControl.value.trim());
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
